export default __webpack_public_path__ + "static/media/pro-mining.aa40ea29.png";